import { AfterViewInit, Component, ElementRef, Input,OnInit, ViewChild,HostListener, QueryList, ViewChildren } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import 'zone.js';
import { calendarDays, calendarMonths } from 'src/app/shared/constants/calendar.constant';
import { GlobalService, Guest, IEventRegisterReq, IRegisterRequest, ResponderQuestionAnswer } from 'src/app/shared/services/global.service';
import {AddToCalendarComponent} from'src/app/components/add-to-calendar/add-to-calendar.component';
import { APP_DEFAULTS, FINRA_DISCLOSURE_TEXT } from 'src/app/shared/constants/app.constants';
@Component({
  selector: 'app-reservation-confirmation',
  templateUrl: './reservation-confirmation.component.html',
  styleUrls: ['./reservation-confirmation.component.scss']
})
export class ReservationConfirmationComponent implements OnInit,AfterViewInit{

@Input() event:any;
@Input() registrationformdata:any;
@Input() showReservationFailure:any;
@Input() langDictionary:any;
@Input() reservationData:any;
@Input() multiEvent:any;

  events:any = [];
  faliureEvents:any = [];
  personalData: any;
  eventAddress: any;
  eventDay: string ='';
  eventMonth:string ='';
  eventTitle:any;
  confirmationDisclaimer:string = '';
  isOpen= false;
  calendarEvent:any;
  isHavingTitles:boolean = false;
  phone:string = '';
  @ViewChild('scrollToPrintsection') scrolltargetprint!: ElementRef;
  @ViewChild('calendarClick') calenderClickEle!: ElementRef; 
  @ViewChildren('calendarClick') calenderClickEles!: QueryList<ElementRef>;

    public finraDisclosure = FINRA_DISCLOSURE_TEXT
    showFinraDisclosure:boolean = false;
constructor(private globalService: GlobalService) {
  
}
  ngOnInit() {
    this.langDictionary = this.globalService.Language; 
    this.phone = this.reservationData?.pageData?.sectionHeader?.phoneNumber || APP_DEFAULTS.PHONE;;

    this.eventTitle = this.reservationData?.pageData?.sectionHeader?.title;
    this.confirmationDisclaimer = this.reservationData?.pageData?.disclaimers?.confirmationDisclaimer
    this.personalData = this.registrationformdata.formsteps[1];
     this.globalService.jobInformation.subscribe((data) => {
        this.showFinraDisclosure = data?.pageData?.disclaimers?.finra;
      })
    if (this.multiEvent == true) {

      //check if all events have title or not?
      this.isHavingTitles = this.event.some((m:any) => m.isTitle == false)   

      this.events = this.event
      .filter((m:any) => m.eventResp.responderEventId > 0)   
      .map((eventItem:any) =>{
        const date = new Date(eventItem?.date)
        const eventEndTime = new Date(eventItem?.EventDateTime);
        const getENdTimeHours = eventEndTime?.getHours() + 2;
        eventEndTime.setHours(getENdTimeHours)
        return{
          calendarIsopen: false,
          monthAbbr:eventItem.monthAbbreviation,
          name:eventItem.Name,
          titleVenue:eventItem.titleVenue,
          time: eventItem.time,
          day:eventItem.day,
          eventAddress : eventItem.Address,
          eventDay : calendarDays[date.getDay()],
          eventMonth : calendarMonths[date.getMonth()],
          calendarEvent: {
            title: this.eventTitle,
            description: '',
            location: eventItem?.Name,
            start: new Date(eventItem?.EventDateTime),
            // end: new Date(this.event?.EventDateTime),
            end: eventEndTime,
            timeZone: eventItem?.TimeZone
          }
        }
      })

      if (this.events && this.events.length <= 0) {
        this.showReservationFailure = true;
      } else {
        this.faliureEvents = this.event.filter((m: any) => m.eventResp.responderEventId <= 0)
          .map((failEvent: any) => {
            const date = new Date(failEvent?.date)
            return {
              titleVenue: failEvent.titleVenue,
              eventDay: calendarDays[date.getDay()],
              eventMonth: calendarMonths[date.getMonth()],
              time: failEvent.time,
              day: failEvent.day,
            }
          })
      }
      
    } else {
      this.event = this.event[0];
      //this.eventTitle = this.reservationData?.pageData?.sectionHeader?.title;
      //this.confirmationDisclaimer = this.reservationData?.pageData?.disclaimers?.confirmationDisclaimer
      //this.personalData = this.registrationformdata.formsteps[1];
      this.eventAddress = this.event?.Address;
      const date = new Date(this.event?.date)
      this.eventDay = calendarDays[date.getDay()]
      this.eventMonth = calendarMonths[date.getMonth()]
      //static end date start//
      const eventEndTime = new Date(this.event?.EventDateTime);
      const getENdTimeHours = eventEndTime?.getHours() + 2;
      eventEndTime.setHours(getENdTimeHours)
      //static end date end//
      this.calendarEvent = {
        title: this.eventTitle,
        description: '',
        location: this.event?.Name,
        start: new Date(this.event?.EventDateTime),
        // end: new Date(this.event?.EventDateTime),
        end: eventEndTime,
        timeZone: this.event?.TimeZone
      };     
    }

  }
ngAfterViewInit(){
          setTimeout(() => {
          const headerOffset = 80; 
          const elementPosition = this.scrolltargetprint.nativeElement.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          //this.scrolltarget.nativeElement.scrollIntoView({ top: offsetPosition, behavior: 'smooth' });
        });
}

  toggleDropdown(event: any) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;

  }

  multiToggleDropdown(item:any, event:any){
    event.stopPropagation();
    item.calendarIsopen = !item.calendarIsopen;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {

    if (!this.multiEvent) {
      if (!this.calenderClickEle) return;
      const clickedOutside = !this.calenderClickEle.nativeElement.contains(event.target);
      if (clickedOutside) {
        this.isOpen = false; // close when clicking outside

      }
      return;
    }


    const anyInside = this.calenderClickEles?.some(el =>
      el.nativeElement.contains(event.target)
    );

    if (!anyInside) {
      // Close ALL open menus
      if (this.events && this.events.length) {
        this.events = this.events.map((e: any) => ({ ...e, calendarIsopen: false }));
        // If you're not OnPush, you can also do:
        // this.events.forEach(e => e.calendarIsopen = false);
      }
    }


  }

  print(){
  window.print();
}
}



